"use client";

import { InfoCircle } from "@untitledui/icons";
import Link from "next/link";

import { capturePosthogEvent } from "@/lib/posthog-browser";
import { useAuth } from "@/providers/auth";

export function PartnerAccessBanner() {
	const { user, isSessionResolving } = useAuth();

	if (isSessionResolving || !user) {
		return null;
	}

	const { partnerBundleExpired, hasStripeSubscription } = user.membership;
	if (!partnerBundleExpired || hasStripeSubscription) {
		return null;
	}

	return (
		<div className="sticky top-0 z-50 w-full border-b border-brand-200 bg-brand-25 px-4 py-3 dark:border-brand-800 dark:bg-brand-950">
			<div className="page-shell flex flex-col gap-2 sm:flex-row sm:items-center sm:justify-between">
				<div className="flex items-start gap-2 sm:items-center">
					<InfoCircle className="mt-0.5 size-5 shrink-0 text-brand-600 sm:mt-0 dark:text-brand-400" />
					<p className="text-sm font-medium text-brand-800 dark:text-brand-200">
						<span className="font-semibold">Your included Pro access has ended.</span> You&apos;re
						on the free plan — upgrade anytime to restore Pro features.
					</p>
				</div>
				<Link
					href="/plans"
					onClick={() => {
						void capturePosthogEvent("partner_access_upgrade_clicked", { source: "banner" });
					}}
					className="shrink-0 rounded-md bg-brand-600 px-3 py-1.5 text-center text-sm font-semibold text-white hover:bg-brand-700 dark:bg-brand-500 dark:hover:bg-brand-400"
				>
					Upgrade to Pro
				</Link>
			</div>
		</div>
	);
}
